import React from 'react'
import { Route, Routes } from 'react-router-dom'
import ChatHistoryReport from './ChatHistoryReport'
import { PageTitle } from '../../layout/core'

interface IProps {
  setChatRoomId: any
}

const ChatHistoryIndex: React.FC<IProps> = ({ setChatRoomId }) => {
  return (
    <>
      <PageTitle breadcrumbs={[]}>Report</PageTitle>
      <ChatHistoryReport setChatRoomId={setChatRoomId} />
    </>
  )
}

export default ChatHistoryIndex
